import * as Styles from './EntriesTable.styles';

import { LOTTERY_COLUMN_HEADINGS } from './constants';

import { EntriesProps } from 'features/LotteryEntries/types';
import { FC } from 'react';
import { FlexContainer } from 'features/common/components/FlexContainer';
import { OUTLINED } from 'features/common/components/Button/constants';
import { Table } from 'features/common/components/Table';
import { TableBody } from './TableBody';
import { useTranslation } from 'react-i18next';

export const EntriesTable: FC<EntriesProps> = ({ entriesQueryObject }) => {
	const { t, i18n } = useTranslation();
	const { fetchNextPage, hasNextPage } = entriesQueryObject;

	const headings = LOTTERY_COLUMN_HEADINGS;

	return (
		<>
			<Table.TableContainer>
				<Table>
					<thead>
						<Styles.HeaderRow gridColumns={`repeat(${headings.length}, 1fr)`} textAlign="center">
							{headings.map((heading) => (
								<Table.Cell key={heading} minWidth={100} maxWidth={450}>
									<Table.ColumnHeader>{i18n.exists(heading) ? t(heading) : heading}</Table.ColumnHeader>
								</Table.Cell>
							))}
						</Styles.HeaderRow>
					</thead>

					<TableBody entriesQueryObject={entriesQueryObject} columnsN={headings.length} />
				</Table>
			</Table.TableContainer>
			<FlexContainer justifyContent="center" margin="32px 0">
				<Table.Button
					category={OUTLINED}
					text={t('button-load-more')}
					onClick={() => fetchNextPage()}
					disabled={!hasNextPage}
					type="button"
				/>
			</FlexContainer>
		</>
	);
};
